<template>
    <div id="images" class="col-md-8 col-sm-12">
        <img class="img-responsive" :src="activePartnumber.ImageLarge" :srcset="activePartnumber.ImageMain + ' 768w,' + activePartnumber.ImageLarge + ' 1199w,'" fetchpriority="high">
        <ul id="thumb-images" style="text-align:center;" v-if="product != null && product.Product?.CloudinaryImagesToPartnumbers != null">
            <li v-for="(thumb, thumbIndex) in product.Product.CloudinaryImagesToPartnumbers" :key="thumbIndex">
                <button :href="thumb.CloudinaryImage.ImageUrlMegaZoomNoTrim" data-fancybox="productphotos" class="productzoom vue-enabled" aria-label="Zoom" v-if="thumb.CloudinaryImage != null && thumb.CloudinaryImage.IsGalleryImage == false">
                    <img :src="thumb.CloudinaryImage.ImageUrlThumbBigger" :alt="thumb.CloudinaryImage.Description" />
                </button>
            </li>
        </ul>
    </div>
    <div class="col-md-4 col-sm-12 question-container">
        <div><h2>{{title}}</h2></div>
        <div v-for="(question, questionIndex) in questions" :key="questionIndex" class="question">
            <p class="subheading">
                <span class="headinglabel">{{ question.Name }}</span>
                <span class="headingvalue" v-show="selected[question.Name] != undefined"> - 
                    <strong>{{getAnswerValue(question)?.Name}}</strong>
                    <!--reset enkel indien er geen default value is opgegeven-->
                    <!--<span v-show="questions.length > 1 && (questionIndex > 0 || containsDefaultValue == false)">
                    - <a href="javascript:void(0)" v-on:click="resetQuestion(questionIndex)">reset</a>
                </span>-->
                </span>
            </p>

            <label v-for="(value, valueIndex) in question.Values" :key="valueIndex" style="display:block;font-weight:normal;" v-show="question.isVisible==true">
                <input type="radio" v-model="selected[question.Name]" :value="value.Id" :disabled="questions.length > 1 && answerContainsPartnumbers(value) == false" @change="openNext(questionIndex)">
                {{ value.Name }}
            </label>
        </div>
        <div v-show="possiblePartnumberCodes.length > 0">
            <h3>Partnumbers:</h3>
            <label v-for="(partnumber, partnumberIndex) in possiblePartnumberCodes" :key="partnumberIndex" style="display:block;font-weight:normal;">
                <input type="radio" v-model="selectedPartnumberCode" name="partnumbercode" :value="partnumber">
                <span style="font-weight:bold;padding-left:10px;">{{ getPartnumber(partnumber).Code }}</span> - <span>{{ getPartnumber(partnumber).Size }}</span> - <span>{{ getPartnumber(partnumber).Color }}</span> - <span>{{ getPartnumber(partnumber).Price }}</span> - <span>{{ getPartnumber(partnumber).Stock }}</span>
            </label>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    /*import SelectedPartnumber from '@/components/SelectedPartnumber.vue';*/

    export default {
        mixins: [cartMixin, generalMixin],
        data: function () {
            return {
                questions: window.combinationsData,
                partnumbers: window.partnumberData,
                selected: {},
                selectedPartnumberCode: '',
                culture: window.culture,
                title: ''
            }
        },
        components: {
            /*SelectedPartnumber*/
        },
        methods: {
            answerContainsPartnumbers(answer) {
                if (this.selectedAnswers.length == 0) {
                    //no option selected. So all available
                    return true;
                } else {
                    return answer.PartnumberCodes.some(item => this.possiblePartnumberCodes.includes(item))
                }
            },
            getPartnumber(code) {
                return this.partnumbers.find(x => x.Code === code);
            },
            getQuestion(name) {
                return this.questions.find(q => q.Name === name);
            },
            getAnswerValue(question) {
                if (this.selected[question.Name] != undefined) {
                    return this.getQuestion(question.Name)?.Values.find(s => s.Id === this.selected[question.Name]);
                }
                return null;
            },
            resetQuestion(question, currentIndex) {
                //rest all questions after this index
                for (var i = currentIndex; i < this.questions.length; i++) {
                    eval('delete this.selected.' + this.questions[i].Name);
                }
                //eval('delete this.selected.' + question.Name);

                //close all other questions
                this.questions.forEach(item => {
                    item.isVisible = false;
                });
                //set current question to visible
                this.questions[currentIndex].isVisible = true;
            },
            openNext(currentIndex) {
                // Check if there is a next question in the list
                if (currentIndex + 1 < this.questions.length) {
                    this.questions[currentIndex + 1].isVisible = true;
                    this.questions[currentIndex].isVisible = false;
                }
            },
            async fetchApi() {
                if (this.productId != null) {
                    await axios.get(this.apiUrl)
                        .then((response) => {
                            vueStore.commit('setProduct', response.data)

                            //set default values
                            var partnumber = response.data.Partnumbers?.filter(x => x.code == this.selectedPartnumberCode)
                            if (partnumber.length > 0) {
                                vueStore.commit('setPartnumber', partnumber[0]);
                            }
                        })
                }
            }
        },
        computed: {
            selectedAnswers() {
                return Object.values(this.selected);
            },
            possiblePartnumberCodes() {
                var that = this;
                // Als ids leeg is, retourneer alle partnumbers
                if (this.selectedAnswers.length === 0) {
                    var allPartnumbers = new Set();

                    // Verzamel partnumbers uit alle categorie�n
                    that.questions.forEach(function (category) {
                        category.Values.forEach(function (value) {
                            value.PartnumberCodes.forEach(function (code) {
                                allPartnumbers.add(code);  // Voeg toe aan de Set voor uniciteit
                            });
                        });
                    });

                    return Array.from(allPartnumbers);  // Zet de Set om naar een array
                }

                // Filteren op basis van gegeven ids
                return this.selectedAnswers.reduce(function (acc, id) {
                    var result = that.questions
                        .find(function (category) {
                            return category.Values.some(function (value) {
                                return value.Id === id;
                            });
                        })
                        .Values.find(function (value) {
                            return value.Id === id;
                        })
                        .PartnumberCodes;

                    // Intersectie berekenen: acc bevat de partnumbers tot nu toe, partnumbers bevat de nieuwe set
                    return acc.length === 0 ? result : acc.filter(function (code) {
                        return result.includes(code);
                    });
                }, []);
            },
            selectedPartnumber() {
                if (this.selectedPartnumberCode != null) {
                    return this.getPartnumber(this.selectedPartnumberCode);
                }
                return null;
            },
            activePartnumber() {
                return this.selectedPartnumber ?? this.getPartnumber(this.possiblePartnumberCodes[0]);
            },
            apiUrl() {
                return '/' + window.culture + '/shop/productselector/' + this.productId + '/1/true'
            },
            product() {
                return vueStore.state.product
            },
            productId() {
                //Pas wanneer 1 product overblijft het product ophalen
                if (this.selectedPartnumber != null) {
                    return this.selectedPartnumber.ProductId;
                }
                return null;
            }
        },
        beforeMount() {
            for (var i = 0; i < this.questions.length; i++) {
                if (i == 0) {
                    this.questions[i].isVisible = true;
                } else {
                    this.questions[i].isVisible = false;
                }
            }
        },
        watch: {
            productId(newValue, oldValue) {
                //productId selected in product configurator
                console.log(`ProductId changed from "${oldValue}" to "${newValue}"`);
                //this.id = newValue;
                //this.producttypeid = 1;
                //get product from Ajax call
                this.fetchApi()
            }
        },

        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.title = document.getElementById('vue-parameters').dataset.title;
        }
    }
</script>
